import { render, staticRenderFns } from "./OrganizationQuickMerge.vue?vue&type=template&id=5b5e4b6a"
import script from "./OrganizationQuickMerge.vue?vue&type=script&lang=ts"
export * from "./OrganizationQuickMerge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports